<template>
    <div class="todoList-module">
        <div class="top-box flex flex-y-center flex-between">
            <div class="top-l flex flex-start flex-y-center">
                <van-dropdown-menu active-color="#35434C">
                    <van-dropdown-item :title='title' ref="type" v-model="type" :options="typeOption" @change="typeChange" />
                </van-dropdown-menu>
            </div>
            <div class="top-r flex-y-center">
                <!-- <div class="open-btn flex flex-y-center flex-x-center" @click="openCalendar">
                </div> -->
                <img v-if="isOpen" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2023-02-17/open.png" class="open-icon" @click="openCalendar" alt="" />
                <img v-else src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2023-02-17/close.png" class="open-icon" @click="openCalendar" alt="" />
                <div class="add-btn" @click="toCreate()">
                    <van-icon name="plus" color="#fff" />
                    新建
                </div>
            </div>
        </div>
        <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
            <div class="main-box flex-col">
                <div class="calendar-box" v-if="isOpen">
                    <div class="date">
                        <div class="arrow-box" @click="handleCalendar('prev')">
                            <div class="arrow-l"></div>
                        </div>
                        <div>{{ year }}年{{ month }}月</div>
                        <div class="arrow-box" @click="handleCalendar('next')">
                            <div class="arrow-r"></div>
                        </div>
                    </div>
                    <div class="content">
                        <div class="header">
                            <div v-for="(item, index) in weeks" :key="index + '1'">
                                <div class="weeks-item-text">{{ item }}</div>
                            </div>
                        </div>
                        <div class="body-days">
                            <div v-for="(item, index) in days" :key="index">
                                <div :class="`days-item ${item.isBlack ? 'no-current' : ''} `" @click="activeItem(item)">
                                    <!-- <div :class="`${currentDate == item.date && ((selectedMonth || month) == item.month) ? 'isActive' : ''}`"> -->
                                    <div :class="`flex-y-center  flex-col  ${currentDate == item.date && ((selectedMonth || month) == item.month) && (item.date == today && item.year + '-' + item.month == dateData) ? 'today-isActive' : (currentDate == item.date && ((selectedMonth || month) == item.month) ? 'isActive' : '')}`">
                                        <div :class="`days-item-today ${item.date == today && item.year + '-' + item.month == dateData && (currentDate == item.date && ((selectedMonth || month) == item.month)) ? '' : 'today'}`" v-if="item.date && item.date == today && item.year + '-' + item.month == dateData">
                                            今天
                                        </div>
                                        <div class="days-item-text" v-else>
                                            {{ item.date }}
                                        </div>
                                        <div :class="`circle ${item.todoClass}`"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="split-line"></div>
                    <div class="remark  flex-y-center flex-end">
                        <div class="flex-y-center">
                            <div class="overdue-color"></div>
                            <span class="type-name ml-10">已逾期</span>
                        </div>
                        <div class="ml-36  flex-y-center ">
                            <div class="completed-color"></div>
                            <span class="type-name ml-10">已完成</span>
                        </div>
                        <div class="ml-36 flex-y-center ">
                            <div class="stay-completed-color"></div>
                            <span class="type-name ml-10">待完成</span>
                        </div>
                    </div>
                </div>
                <div class="list" v-if="todoGroupList.length != 0">
                    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getTodoList" :offset="20" :immediate-check="false">
                        <div v-for="item, index in todoGroupList" :key="index">
                            <div class="list-title">{{ item.remindDate }}</div>
                            <div class="list-inner" v-for="oItem, oIndex in item.data" :key="oIndex + '2'">
                                <div class="inner-top flex flex-y-center">
                                    <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/task.png" alt="" class="task-icon" />
                                    {{ oItem.title }}
                                </div>
                                <div class="split-line"></div>
                                <div class="inner-main flex flex-between">
                                    <div class="radio-box">
                                        <van-checkbox v-model="oItem.isCheck" :disabled="getTodoCheckDisabled(item.remindDate, oItem.isCheck, oItem.status)" @change="todoCheck(oItem.id)">
                                        </van-checkbox>
                                    </div>
                                    <div class="inner-info flex-1">
                                        <div class="info-tit">{{ oItem.message }}</div>
                                        <div class="info-time">
                                            <van-icon name="clock-o" />&nbsp;截止当日{{ oItem.closingDateTime }}
                                        </div>
                                        <!-- 任务样式 暂不用 -->
                                        <!-- <div class="info-remain flex flex-between flex-y-center" v-if="false">
                                            <img src="https://staticpos.beautyfarm.com.cn/pos_wechat/shop/head.png"
                                                class="head-icon" />
                                            <div class="flex-1 flex-y-center ml-20">企微管家 客服</div>
                                            <div class="follow">
                                                跟进
                                                <van-icon name="arrow" color="#CCCCCC" />
                                            </div>
                                        </div> -->
                                        <div class="info-remain flex flex-between flex-y-center">
                                            <div class="flex flex-1 ml-20">
                                                <img v-for="(items, indexs) in oItem.avatarUrlList" :key="indexs + '3'" :src="items" alt="" class="head-icon head-icon-m" />
                                            </div>
                                            <div class="follow" @click="toDetail(oItem)">
                                                查看详情
                                                <van-icon name="arrow" color="#CCCCCC" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </van-list>
                </div>
                <div v-else class="empty-box flex flex-col">
                    <div class="empty-title">{{ nullToDoDate }}</div>
                    <div class="empty-main  flex-col">
                        <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/null.png" alt="" class="empty-icon" />
                        <div class="empty-txt">没有待开始的待办～</div>
                    </div>
                </div>
            </div>
        </van-pull-refresh>

    </div>
</template>

<script>
    import request from "@/utils/request";
    import { Toast } from 'vant'
    import {
        padZero, getTodoCheckDisabled
    } from './utils'
    const TYPE_NAME = 'todo-list-type'
    const DEFAULT_SELECTED_DATE = 'todo-list-default-selected-date'

    var u = navigator.userAgent, app = navigator.appVersion;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);  //根据输出结果true或者false来判断ios终端
    // let time4 = isiOS ? new Date(datetime.replace(/-/g, '/')).getTime() : new Date(datetime).getTime();
    export default {
        name: 'todoList',
        components: {},
        data() {
            return {
                status: false,
                type: '1', //状态
                typeOption: [
                    { text: '待开始', value: '1' },
                    { text: '已完成', value: '2' },
                    { text: '已逾期', value: '3' },
                ],
                date: [],
                weeks: ['日', '一', '二', '三', '四', '五', '六'],
                days: [],
                year: 0,
                month: 0,
                today: '', // 所选日期是否是当天
                scheduleData: [], // 排班数据
                dateData: '', // 当前查询的年月
                currentDate: '', //当前所点击日期（day
                isOpen: true, //是否展开日历
                loading: false,
                finished: false,
                refreshing: false,
                page: 1,
                total: 0,
                todoGroupList: [],
                selectedMonth: null,
                selectedYear: null,
                times: new Date().getTime(),
                title: '',
                nullToDoDate: '',  //无数据时当前时间
            }
        },
        watch: {
            currentDate() {
                sessionStorage.setItem(DEFAULT_SELECTED_DATE, JSON.stringify({
                    defaultYear: this.selectedYear ?? this.year,
                    defaultMonth: this.selectedMonth ?? this.month,
                    defaultDate: this.currentDate,
                    currentYear: this.year,
                    currentMonth: this.month
                }))
            }
        },
        mounted() {
            this.type = sessionStorage.getItem(TYPE_NAME) ?? this.type
            this.initDate()
            this.getTodoList()
            this.getCalendar()
        },
        methods: {
            getTodoCheckDisabled,
            // 获取日历状态
            getCalendar() {
                const todoClassMap = {
                    1: 'pending',//待开始
                    2: 'completed',// 完成
                    3: 'overdue'//逾期
                }
                request({
                    url: `/todo/calendar`,
                    method: "get",
                    params: { month: `${this.year}-${padZero(this.month, 2)}` }
                }).then((res) => {
                    const calendarList = res.data ?? []
                    const calendarMap = {}
                    calendarList.forEach(item => {
                        calendarMap[item.remindDate] = item.todoStatus
                    })
                    this.days.forEach(item => {
                        const day = `${item.year}-${padZero(item.month, 2)}-${padZero(item.date, 2)}`
                        this.$set(item, 'todoClass', todoClassMap[calendarMap[day]])
                    })
                })
            },
            // 获取待办列表数据
            getTodoList() {
                const limit = 10
                let todoDate = ''
                if (this.isOpen) {
                    todoDate = [this.selectedYear ?? this.year, this.selectedMonth ?? this.month, this.currentDate].join('-')
                }
                this.nullToDoDate = `${this.year}-${padZero(this.selectedMonth ?? this.month, 2)}-${padZero(this.currentDate, 2)}`;
                this.loading = true
                request({
                    url: `/todo/index`,
                    method: "get",
                    params: { limit, page: this.page, todoDate, todoStatus: this.type }
                })
                    .then((res) => {
                        // 列表数据按日期分组
                        const { list = [] } = res.data || {}
                        for (const item of list) {
                            const groupLength = this.todoGroupList.length
                            // 1-待开始；2-已完成；3-已逾期 只有当1且为当天是可选/3可选，其余禁选
                            item.isCheck = item.status === 2
                            if (groupLength && this.todoGroupList[groupLength - 1].remindDate === item.remindDate) {
                                this.todoGroupList[groupLength - 1].data.push(item)
                            } else {
                                this.todoGroupList.push({
                                    remindDate: item.remindDate,
                                    data: [item]
                                })
                            }
                        }
                        if (list.length < limit) {
                            this.finished = true
                        }
                        this.page += 1
                    }).catch(() => {
                        this.finished = true
                    }).finally(() => {
                        this.loading = false
                        this.refreshing = false
                    })
            },
            // 初始化时间
            initDate() {
                const date = new Date()
                this.today = date.getDate()
                const currentYear = date.getFullYear()
                const currentMonth = date.getMonth() + 1
                this.dateData = `${currentYear}-${currentMonth}`

                const defaultData = sessionStorage.getItem(DEFAULT_SELECTED_DATE)
                if (defaultData) {
                    const { defaultYear, defaultMonth, defaultDate, currentYear, currentMonth } = JSON.parse(defaultData)
                    this.selectedYear = Number(defaultYear)
                    this.selectedMonth = Number(defaultMonth)
                    this.year = Number(currentYear)
                    this.month = Number(currentMonth)
                    this.currentDate = Number(defaultDate)
                } else {
                    this.year = currentYear
                    this.month = currentMonth
                    this.currentDate = this.today
                }

                this.updateDays()
            },
            onRefresh() {
                this.page = 1
                this.finished = false;
                this.todoGroupList = []
                this.getTodoList()
                this.isOpen && this.getCalendar()
            },
            // 点击时背景变色，和获取当天任务状态（根据todoClass判断
            activeItem(item) {
                const { date, month, year, todoClass } = item
                if (date && (((this.selectedMonth ?? this.month) + this.currentDate) !== month + date)) {
                    this.currentDate = date // 当前点击的日期数
                    this.selectedMonth = month
                    this.selectedYear = year
                    // this.onRefresh()
                }
                //  1-待开始；2-已完成；3-已逾期
                if (todoClass == 'pengding') {
                    this.type = 1
                } else if (todoClass == 'completed') {
                    this.type = 2
                } else if (todoClass == 'overdue') {
                    this.type = 3
                } else {
                    this.type = 1
                }
                // this.$refs.type.toggle()
                this.typeChange(this.type)
            },
            // 显示日历 
            openCalendar() {
                this.isOpen = !this.isOpen
                this.onRefresh()
            },
            // 获取上月和下月月份
            getNextAndPreMonth(month) {
                return {
                    preMonth: month - 1 < 1 ? 12 : month - 1,
                    nextMonth: month + 1 > 12 ? 1 : month + 1
                }
            },
            getMonthYear(year, month) {
                return {
                    preMonthYear: month - 1 < 1 ? year - 1 : year,
                    nextMonthYear: month + 1 > 12 ? year + 1 : year
                }
            },
            // 切换月份
            handleCalendar(handle) {
                const { preMonth, nextMonth } = this.getNextAndPreMonth(this.month)
                const { preMonthYear, nextMonthYear } = this.getMonthYear(this.year, this.month)
                if (handle === 'prev') {
                    this.year = preMonthYear
                    this.month = preMonth
                    this.selectedYear = preMonthYear
                    this.selectedMonth = preMonth
                } else {
                    this.year = nextMonthYear
                    this.month = nextMonth
                    this.selectedYear = nextMonthYear
                    this.selectedMonth = nextMonth
                }
                this.currentDate = new Date(this.selectedYear, this.selectedMonth, 1).getDate()
                this.updateDays()
                this.onRefresh()
            },
            // 更新月份天数
            updateDays() {
                const year = this.year
                const month = this.month
                var days = []
                var dateDay, dateWeek, lastWeek
                dateDay = this.getThisMonthDays(year, month)
                dateWeek = this.getFirstDayOfWeek(year, month)
                lastWeek = this.getLastDayOfWeek(year, month)
                const typeMap = {
                    早班: 1,
                    中班: 2,
                    晚班: 3,
                    休班: 4,
                    未排班: 5,
                }
                //向数组中添加天
                for (let index = 1; index <= dateDay; index++) {
                    days.push({
                        date: index,
                        current: true, // 是不是当月的日期
                        month: month,
                        year: year,
                        text: this.scheduleData[index - 1]?.scheduleType,
                        type: typeMap[this.scheduleData[index - 1]?.scheduleType] || undefined,
                        // a:isios?y-m-d<today:y/m/d<tody
                        isBlack: isiOS ? new Date(`${year}/${month}/${index}`).getTime() < this.times : new Date(`${year}-${month}-${index}`).getTime() < this.times
                    })
                }
                // 获取本月第一天的上一天是几号
                let time = new Date(year + '/' + month + '/' + 1).getTime() - 24 * 60 * 60 * 1000
                let yesterday = new Date(time).getDate()
                const { preMonth, nextMonth } = this.getNextAndPreMonth(month)
                const { preMonthYear, nextMonthYear } = this.getMonthYear(year, month)
                //向数组中添加，一号之前应该空出的空格
                for (let index = 1; index <= dateWeek; index++) {
                    days.unshift({
                        date: yesterday--,
                        current: false,
                        month: preMonth,
                        year: preMonthYear,
                        isBlack: isiOS ? new Date(`${preMonthYear}/${preMonth}/${index}`).getTime() < this.times : new Date(`${preMonthYear}-${preMonth}-${index}`).getTime() < this.times
                    })


                }
                //向数组中添加，最后一天之后应该空出的空格
                for (let index = 1; index <= 6 - lastWeek; index++) {
                    days.push({
                        date: index,
                        current: false,
                        month: nextMonth,
                        year: nextMonthYear,
                        isBlack: isiOS ? new Date(`${nextMonthYear}/${nextMonth}/${index}`).getTime() < this.times : new Date(`${nextMonthYear}-${nextMonth}-${index}`).getTime() < this.times
                    })
                }
                this.days = days
            },
            // 获取当月共多少天
            getThisMonthDays(year, month) {
                return new Date(year, month, 0).getDate()
            },
            // 获取当月第一天星期几
            getFirstDayOfWeek(year, month) {
                return new Date(Date.UTC(year, month - 1, 1)).getDay()
            },
            // 获取当月最后一天星期几
            getLastDayOfWeek(year, month) {
                let _time = new Date(year + '/' + (month + 1) + '/' + 1).getTime() - 24 * 60 * 60 * 1000
                let lastDay = new Date(_time).getDate()
                return new Date(Date.UTC(year, month - 1, lastDay)).getDay()
            },
            // 跳转详情
            toDetail(item) {
                // 自建任务去编辑/新建页
                if (item.type == 5) {
                    this.$router.push({ name: "createToDo", query: { id: item.id } });
                } else {
                    this.$router.push({ name: "toDoDetail", query: { custId: item.id } });
                }
            },
            // 跳转新建
            toCreate() {
                this.$router.push({ name: "createToDo" });
            },
            // 是否可选
            todoCheck(todoId) {
                request({
                    url: `/todo/${todoId}`,
                    method: "put",
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
            },
            typeChange(num) {
                this.title = this.typeOption[num - 1].text
                sessionStorage.setItem(TYPE_NAME, this.type)
                this.onRefresh()
            }
        },
    }
</script>

<style scoped lang="less">
    .ml-20 {
        margin-left: 20px;
    }

    ::-webkit-scrollbar {
        display: none;
    }

    .todoList-module {
        height: 100%;
        box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02) inset;
        background-color: #f5f6f7;
        overflow-y: auto;
    }

    .top-box {
        position: relative;
        width: 750px;
        height: 102px;
        background: #ffffff;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
        padding: 30px;
        z-index: 99;

        .top-l {
            .status {
                font-size: 30px;
                font-weight: 700;
                color: #35434c;
                line-height: 102px;
            }

            .num {
                font-size: 28px;
                font-weight: 400;
                color: #c4ced4;
                line-height: 102px;
                margin-left: 10px;
            }

            .arrow {
                width: 20px;
                height: 11px;
                margin-left: 17px;
            }
        }

        .top-r {
            .open-btn {
                width: 80px;
                height: 56px;
                background: #f0f0f0;
                border-radius: 25px;
                margin-right: 20px;
            }

            .open-icon {
                width: 80px;
                height: 56px;
                margin-right: 20px;
            }

            .add-btn {
                position: relative;
                z-index: 1;
                width: 125px;
                height: 56px;
                background: #2fd0d5;
                border-radius: 29px;
                color: #fff;
                font-size: 26px;
                line-height: 56px;
                text-align: center;

                :deep(.van-icon.van-icon-plus) {
                    font-size: 26px !important;
                }
            }
        }
    }

    // 日历
    .calendar-box {
        background-color: #ffffff;
        margin: 30px 30px 0 30px;
        min-height: 756px;
        border-radius: 10px;

        .date {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            line-height: 92.4px;
            margin: 0 41px;
            font-size: 30px;
            color: #35434c;
        }

        .arrow-box {
            width: 40px;
            height: 30px;
            display: flex;
            align-items: center;
        }

        .arrow-l {
            width: 0;
            height: 0;
            border-top: 10px solid transparent;
            border-right: 10px solid #35434c;
            border-bottom: 10px solid transparent;
            margin-right: 30px;
        }

        .arrow-r {
            width: 0;
            height: 0;
            border-top: 10px solid transparent;
            border-left: 10px solid #35434c;
            border-bottom: 10px solid transparent;
            margin-left: 30px;
        }

        // .content {
        //     padding: 20px 20px;
        // }

        .header {
            display: flex;
            flex-direction: row;
            margin-bottom: 30px;
            justify-content: space-between;
        }

        .weeks-item-text {
            width: 95px;
            line-height: 48px;
            text-align: center;
            color: #66757f;
            font-size: 28px;
            font-weight: bold;
        }

        .body-days {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            text-align: center;
            padding-bottom: 10px;
            justify-content: space-between;
        }

        .days-item {
            width: 95px;
            height: 68px;
            display: flex;
            justify-content: center;
            align-content: center;
            margin-bottom: 28px;
            color: #35434c;
            flex-direction: column;
            font-size: 28px;
            box-sizing: border-box;
            position: relative;
            align-items: center;
        }

        .days-item-text {
            font-size: 28px;
            text-align: center;
        }

        .today {
            color: #35434c;
        }

        .today-check {
            color: #ffffff;
        }

        .days-item-today {
            font-size: 28px;
            text-align: center;
            font-weight: 700;
        }

        .date-1 {
            color: #fbc200;
        }

        .date-2 {
            color: #fa9063;
        }

        .date-3 {
            color: #9a6be2;
        }

        .date-4 {
            color: #41daa5;
        }

        .date-5 {
            color: #c4ced4;
        }

        .days-item.no-current {
            color: #c4ced4;
        }

        // .days-item.isActive {
        //     background-color: #39d6cb;
        //     border: 1px solid #39d6cb;
        //     // background: #39d6cb;
        // }

        .isActive {
            width: 52px;
            height: 52px;
            line-height: 50px;
            background-color: #39d6cb;
            border: 1px solid #39d6cb;
            border-radius: 40px;
            color: #ffffff;
        }

        .today-isActive {
            width: 60px;
            height: 60px;
            line-height: 60px;
            background-color: #39d6cb;
            border: 1px solid #39d6cb;
            border-radius: 40px;
            color: #ffffff;
        }

        .days-item.isNoActive {
            background-color: #fff;
            border: none;
        }

        .circle {
            flex-shrink: 0;
            width: 10px;
            height: 10px;
            position: absolute;
            left: 50%;
            bottom: -10px;
            margin-left: -6px;
            border-radius: 50%;

            &.pending {
                background-color: #ffc234;
            }

            &.completed {
                background-color: #37dbe0;
            }

            &.overdue {
                background-color: #ff4545;
            }
        }

        .remark {
            padding-right: 29px;
            height: 93px;

            // border-top: 1px solid rgba(215, 215, 215, 0.5);
            .overdue-color {
                width: 10px;
                height: 10px;
                background: #ff4545;
                border-radius: 50%;
            }

            .completed-color {
                width: 10px;
                height: 10px;
                background: #37dbe0;
                border-radius: 50%;
            }

            .stay-completed-color {
                width: 10px;
                height: 10px;
                background: #ffc234;
                border-radius: 50%;
            }

            .type-name {
                font-size: 24px;
                color: #66757f;
            }

            .ml-10 {
                margin-left: 10px;
            }

            .ml-36 {
                margin-left: 36px;
            }
        }
    }

    .main-box {
        min-height: calc(100vh - 102px);
    }

    // 列表
    .list {
        padding: 40px 30px;
        flex: 1;
        margin-bottom: 50px;

        .list-title {
            height: 42px;
            font-size: 30px;
            font-weight: 700;
            color: #35434c;
            line-height: 42px;
            margin-bottom: 30px;
        }

        .list-inner {
            width: 690px;
            // height: 343px;
            margin-bottom: 30px;
            background: #ffffff;
            box-shadow: 0px 6px 26px 0px rgba(2, 2, 2, 0.08);
            border-radius: 20px;

            .inner-top {
                width: 690px;
                height: 90px;
                background: #ffffff;
                border-radius: 20px 20px 0px 0px;
                padding: 24px 20px;
                color: #35434c;
                font-size: 30px;
                font-weight: 700;
                // border-bottom: 1px solid rgba(215, 215, 215, 0.5);
            }

            .task-icon {
                width: 30px;
                height: 30px;
                margin-right: 20px;
            }

            .inner-main {
                padding: 34px 20px;

                .radio-box {
                    width: 50px;
                    height: 40px;
                    margin: 6px 0 20px 0;
                    // margin-right: 20px;
                }

                .info-tit {
                    width: 598px;
                    overflow: hidden;
                    /*超出部分隐藏*/
                    white-space: nowrap;
                    /*禁止换行*/
                    text-overflow: ellipsis;
                    /*省略号*/
                    font-size: 28px;
                    color: #35434c;
                    margin-bottom: 20px;
                }

                .info-time {
                    font-size: 28px;
                    font-weight: 400;
                    color: #a0acb5;
                    margin-bottom: 36px;
                }

                .info-remain {
                    width: 598px;
                    height: 70px;
                    background: #e9f2ff;
                    border-radius: 4px;
                    color: #a0acb5;
                    font-size: 28px;
                    padding: 12px 20px;

                    .head-icon {
                        width: 46px;
                        height: 46px;
                        border-radius: 50%;
                    }

                    .head-icon-m {
                        margin-left: -18px;
                    }
                }

                :deep(.van-checkbox__icon .van-icon) {
                    width: 32px;
                    height: 32px;
                    line-height: 32px;
                }

                :deep(.van-checkbox__icon--checked .van-icon) {
                    background-color: #fff;
                    border-color: #a0acb5;
                    color: #a0acb5;
                }
            }
        }
    }

    .box {
        box-shadow: 0px 6px 26px 0px rgba(2, 2, 2, 0.08);
    }

    .empty-box {
        // flex: 1;
        // background-color: #fff;
        padding: 40px 30px;
    }

    .empty-main {
        align-items: center;
    }

    .empty-icon {
        width: 210px;
        height: 210px;
        margin-top: 40px;
    }

    .empty-txt {
        font-size: 30px;
        color: #a0acb5;
    }

    .empty-title {
        height: 42px;
        font-size: 30px;
        font-weight: 700;
        color: #35434c;
        line-height: 42px;
        // margin-bottom: 40px;
    }

    .split-line {
        width: 690px;
        height: 1px;
        background: #d7d7d7;
        opacity: 0.5;
    }

    :deep(.van-dropdown-menu) {
        font-weight: 700;
    }

    :deep(.van-dropdown-menu__bar) {
        box-shadow: none;
    }

    :deep(.van-dropdown-item__content) {
        border-radius: 0px 0px 36px 36px;
    }

    :deep(.van-dropdown-menu__title::after) {
        border-color: transparent transparent #35434c #35434c !important;
    }
</style>
